'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var multipartRequest = require('../lib/multipart-request');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var abortSignal = require('../lib/abort-signal');

var _require2 = require('native-abort-controller'),
    AbortController = _require2.AbortController;

var uint8ArrayToString = require('uint8arrays/to-string');

var uint8ArrayFromString = require('uint8arrays/from-string');
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/object').API<HTTPClientExtraOptions>} ObjectAPI
 */


module.exports = configure(function (api) {
  /**
   * @type {ObjectAPI["put"]}
   */
  function put(_x) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj) {
      var options,
          tmpObj,
          buf,
          controller,
          signal,
          res,
          _yield$res$json,
          Hash,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              tmpObj = {
                /** @type {string | undefined} */
                Data: undefined,

                /** @type {{ Name: string, Hash: string, Size: number }[]} */
                Links: []
              };

              if (!(obj instanceof Uint8Array)) {
                _context.next = 6;
                break;
              }

              if (!options.enc) {
                tmpObj = {
                  // FIXME: this will corrupt data for byte values over 127
                  Data: uint8ArrayToString(obj),
                  Links: []
                };
              }

              _context.next = 16;
              break;

            case 6:
              if (!(obj instanceof DAGNode)) {
                _context.next = 10;
                break;
              }

              tmpObj = {
                // FIXME: this will corrupt data for byte values over 127
                Data: uint8ArrayToString(obj.Data),
                Links: obj.Links.map(function (l) {
                  return {
                    Name: l.Name,
                    Hash: l.Hash.toString(),
                    Size: l.Tsize
                  };
                })
              };
              _context.next = 16;
              break;

            case 10:
              if (!(typeof obj === 'object')) {
                _context.next = 15;
                break;
              }

              // FIXME: this will corrupt data for for byte values over 127
              if (obj.Data) {
                tmpObj.Data = uint8ArrayToString(obj.Data);
              }

              if (obj.Links) {
                // @ts-ignore Size is Tsize
                tmpObj.Links = obj.Links;
              }

              _context.next = 16;
              break;

            case 15:
              throw new Error('obj not recognized');

            case 16:
              if (obj instanceof Uint8Array && options.enc) {
                buf = obj;
              } else {
                options.enc = 'json';
                buf = uint8ArrayFromString(JSON.stringify(tmpObj));
              } // allow aborting requests on body errors


              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                timeout: options.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(options)
              };
              _context.next = 24;
              return multipartRequest(buf, controller, options.headers);

            case 24:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 28;
              return _context.t0.post.call(_context.t0, 'object/put', _context.t4);

            case 28:
              res = _context.sent;
              _context.next = 31;
              return res.json();

            case 31:
              _yield$res$json = _context.sent;
              Hash = _yield$res$json.Hash;
              return _context.abrupt("return", new CID(Hash));

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});